"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialized = exports.cancel = void 0;
exports.cancel = '@event/CANCEL';
exports.initialized = '@event/INITIALIZED';
//# sourceMappingURL=Events.js.map